import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { LocalStop } from '../../shared/local-stop.model';
import { LocalShipment } from '../../shared/local-shipment.model';
import { LocalLoadService } from '../../shared/local-load.service';
import { LocalLoadDocument } from '../../shared/local-load-document.model';
import { LoaderService } from '../../../shared/services/loader.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-stop-details',
  templateUrl: './stop-details.component.html',
  styleUrls: ['./stop-details.component.scss']
})
export class StopDetailsComponent implements OnInit {

  @Input()
  stop: LocalStop;

  @ViewChild('stopElement')
  stopElement: ElementRef;

  zoom = 15;

  constructor(
    private localLoadService: LocalLoadService,
    private loader: LoaderService
  ) {
  }

  ngOnInit() {
  }

  expandShipment(shipment: LocalShipment) {
    shipment.expand();
  }

  scrollTo() {
    const nativeElement: HTMLDivElement = this.stopElement.nativeElement;
    window.scrollTo({ top: nativeElement.offsetTop - 10, behavior: 'smooth' });
  }

  downloadPod(pod: LocalLoadDocument) {
    this.loader.startLoad();

    this.localLoadService.downloadPod(pod.id)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe();
  }

}
